import React, { useState, useEffect } from 'react'
import Icons from '../../../components/UI/Icons';
import { useDispatch } from 'react-redux';
import { success } from '../../../store/CommonSlice';
import OrganizationService from '../../../services/OrganizationService';
import http from '../../../services/http';
import EmrConfigService from '../../../services/EmrConfigService';
import FormInputs from '../../../components/UI/FormInputs';
import AiDiagnosisService from '../../../services/AiDiagnosisService';
import EmrVisitsService from '../../../services/EmrVisitsService';


const SubTabChartingSection = (props) => {
  const {
    fields,
    normalCheckedFormIds,
    handleNormalSubmit,
    setNormalCheckedFormIds,
    setSelectedFormIds,
    selectedFormIds,
    handleCheckboxChange,
    fieldSearched,
    handleSearch,
    SetFieldSearched,
    allSelected,
    setCompetedFormIds,
    searchTerm,
    setSearchTerm,
    setActiveSearchSource,
    setCurrentSearchLabel,
    activeSearchSource,
    selectedTab,
    selectedSubTab,
    subTabs,
    handleTick,
    finishedSubTabs,
    finishedTabs,
    setFormState,
    formState,
    formResponses,
    isChartingSectionDirty,
    setIsChartingSectionDirty,
    checkUnsavedChanges,
    saveCurrentChartingAndProceed,
    visit_id,
    fetchEmrList,
    toggleStatus,
    setToggleStatus,
    visitDetails,
    employeeId,
    profile,
    fetchProgressNotesByScreen,
    Loader,
  } = props;
  
  const dispatch = useDispatch();
  const [isHpiAiPredictiveOpen, setIsHpiAiPredictiveOpen] = useState(true);
  const [hpiAiSuggestions, setHpiAiSuggestions] = useState([]);
  const [hpiAiLoading, setHpiAiLoading] = useState(false);
  const [hpiAiLoadingStep, setHpiAiLoadingStep] = useState(0);
  const [hpiAiError, setHpiAiError] = useState("");
  const [lastKnownHpiSuggestionTimestamp, setLastKnownHpiSuggestionTimestamp] = useState(null);
  const [newHpiSuggestionsAvailable, setNewHpiSuggestionsAvailable] = useState(false);
  const [isHpiPollingForNewSuggestions, setIsHpiPollingForNewSuggestions] = useState(false);
  const [hasHpiCompletedPolling, setHasHpiCompletedPolling] = useState(false);
  const [isHpiEditModalOpen, setIsHpiEditModalOpen] = useState(false);
  const [hpiEditText, setHpiEditText] = useState("");
  const [hpiEditSuggestion, setHpiEditSuggestion] = useState(null);

  // MDM / Plan editor modal state
  const [isMdmPlanEditModalOpen, setIsMdmPlanEditModalOpen] = useState(false);
  const [mdmPlanEditText, setMdmPlanEditText] = useState("");
  const [mdmPlanEditSelections, setMdmPlanEditSelections] = useState({});
  const [mdmPlanEditSuggestion, setMdmPlanEditSuggestion] = useState(null);

  // MDM / Plan AI card state
  const [isMdmPlanAiPredictiveOpen, setIsMdmPlanAiPredictiveOpen] = useState(true);
  const [mdmPlanAiSuggestions, setMdmPlanAiSuggestions] = useState([]);
  const [mdmPlanAiLoading, setMdmPlanAiLoading] = useState(false);
  const [mdmPlanAiLoadingStep, setMdmPlanAiLoadingStep] = useState(0);
  const [mdmPlanAiError, setMdmPlanAiError] = useState("");
  const [newMdmPlanSuggestionsAvailable, setNewMdmPlanSuggestionsAvailable] = useState(false);
  const [lastKnownMdmPlanSuggestionTimestamp, setLastKnownMdmPlanSuggestionTimestamp] = useState(null);
  const [isMdmPlanPollingForNewSuggestions, setIsMdmPlanPollingForNewSuggestions] = useState(false);
  const aiPredictiveCardStyle = {
    padding: "8px",
    borderRadius: "12px",
    border: "2px solid transparent",
    background:
      "linear-gradient(#fff, #fff) padding-box, linear-gradient(76.49deg, #C6CCFF 0.38%, #F1F3FC 99.62%) border-box",
  };
  const aiPredictiveTitleStyle = {
    color: "#1D2433",
    fontSize: "13px", // match main card headers like "Order and Result"
    fontWeight: 700,
  };
  const aiPredictiveListStyle = {
    background: "linear-gradient(180deg, #FFE9FF 0%, #FDEFFF 40%, #FDF3FF 100%)",
    padding: "8px",
    maxHeight: "380px",
    overflowY: "auto",
    scrollbarWidth: "thin",
    borderRadius: "8px",
  };
  const aiPredictiveCodeStyle = {
    color: "#1D2433",
    fontSize: "13px", // align with table cell text
    fontWeight: 700,
    lineHeight: 1.25,
  };
  const aiPredictiveDescStyle = {
    color: "#4B5563",
    fontSize: "13px", // align with table cell text
    lineHeight: 1.35,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    maxHeight: "2.7em",
  };
  const hpiLoadingMessages = [
    "Reviewing injury details and chief complaint...",
    "Analyzing mechanism of injury and work activity...",
    "Building the injury timeline from event to visit...",
    "Evaluating occupational symptoms and ROS...",
    "Applying ACOEM documentation standards...",
    "Structuring the HPI narrative...",
    "Finalizing medico-legal documentation...",
  ];

  const mdmPlanLoadingMessages = [
    "Reviewing diagnosis and chart context...",
    "Structuring MDM/Plan reasoning...",
    "Drafting clinical narrative...",
    "Finalizing MDM/Plan documentation...",
  ];
  const MDM_PLAN_DICTATION_FORM_ID = "ce9773d2554c422f9e706e0488440114";
  const MDM_PLAN_DICTATION_FIELD_ID = "08675fa8b5c049bd9759165e3362f35a";

  
  const parseMdmSuggestionDescription = (description) => {
    if (description === undefined || description === null) return null;
    if (typeof description === "object") return description;
    if (typeof description === "string") {
      try {
        return JSON.parse(description);
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  const buildMdmSelectionsSummaryText = (selectionsObj) => {
    if (!selectionsObj || typeof selectionsObj !== "object") return "";

    const lines = [];
    Object.entries(selectionsObj).forEach(([fieldLabel, columns]) => {
      if (!columns || typeof columns !== "object") return;
      Object.entries(columns).forEach(([columnLabel, optionValues]) => {
        if (!Array.isArray(optionValues) || optionValues.length === 0) return;
        lines.push(`${fieldLabel} - ${columnLabel}: ${optionValues.join(", ")}`);
      });
    });

    return lines.length > 0 ? lines.join("\n") : "";
  };

  const escapeHtml = (str) =>
    String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const formatNarrativeToHtml = (narrative) => {
    const raw = String(narrative || "").trim();
    if (!raw) return "";
    // Keep existing rich HTML if it already looks like HTML
    if (/<[a-z][\s\S]*>/i.test(raw)) return raw;
    let escaped = escapeHtml(raw).replace(/\n/g, "<br/>");
    escaped = escaped.replace(
      /^MDM\s*\/\s*Plan\s*:/i,
      "<strong>MDM/Plan:</strong>"
    );
    return `<p>${escaped}</p>`;
  };

  const buildMdmSelectionsSummaryHtml = (selectionsObj) => {
    if (!selectionsObj || typeof selectionsObj !== "object") return "";

    const rows = [];
    Object.entries(selectionsObj).forEach(([fieldLabel, columns]) => {
      if (!columns || typeof columns !== "object") return;
      Object.entries(columns).forEach(([columnLabel, optionValues]) => {
        if (!Array.isArray(optionValues) || optionValues.length === 0) return;
        rows.push(
          `<p><strong>${escapeHtml(fieldLabel)}</strong> - ${escapeHtml(columnLabel)}: ${escapeHtml(
            optionValues.join(", ")
          )}</p>`
        );
      });
    });

    return rows.join("");
  };

  const buildMdmEditorHtml = (narrative, selectionsObj) => {
    const narrativeHtml = formatNarrativeToHtml(narrative);
    const selectionsHtml = buildMdmSelectionsSummaryHtml(selectionsObj);
    if (!selectionsHtml) return narrativeHtml;
    return `${narrativeHtml}<p><br/></p>${selectionsHtml}`;
  };

  const normalizeMdmNarrativeForSave = (value, selectionsMap) => {
    let html = String(value || "").trim();
    if (
      html === "<p><br></p>" ||
      html === "<p><br/></p>" ||
      html === "<p><br /> </p>"
    ) {
      return "";
    }

    // Convert editor HTML to plain text for EMR field save.
    // HTML should stay in Quill view only, not in stored field value.
    html = html
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<p(?:\s[^>]*)?>/gi, "");

    let text = html.replace(/<[^>]+>/g, "");

    // Decode any escaped HTML entities if browser DOM is available.
    if (typeof document !== "undefined") {
      const tmp = document.createElement("textarea");
      tmp.innerHTML = text;
      text = tmp.value;
    }

    // Remove appended AI selection lines from the narrative field value.
    const summary = buildMdmSelectionsSummaryText(selectionsMap || {});
    const summaryLines = summary
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);

    summaryLines.forEach((line) => {
      if (!line) return;
      text = text.replace(line, "");
    });

    // Hard stop at first selected field label if still present in text.
    const labels = Object.keys(selectionsMap || {})
      .map((k) => String(k || "").trim())
      .filter(Boolean);
    if (labels.length > 0) {
      const lowered = text.toLowerCase();
      let cutIdx = -1;
      labels.forEach((label) => {
        const idx = lowered.indexOf(label.toLowerCase());
        if (idx !== -1 && (cutIdx === -1 || idx < cutIdx)) {
          cutIdx = idx;
        }
      });
      if (cutIdx > 0) {
        text = text.slice(0, cutIdx);
      }
    }

    return text
      .replace(/[ \t]+\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  };

  const normalizeEditorHtmlToPlainText = (value) => {
    let html = String(value || "").trim();
    if (
      html === "" ||
      html === "<p><br></p>" ||
      html === "<p><br/></p>" ||
      html === "<p><br /> </p>"
    ) {
      return "";
    }

    html = html
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<p(?:\s[^>]*)?>/gi, "");

    let text = html.replace(/<[^>]+>/g, "");

    if (typeof document !== "undefined") {
      const tmp = document.createElement("textarea");
      tmp.innerHTML = text;
      text = tmp.value;
    }

    return text
      .replace(/[ \t]+\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  };

  useEffect(() => {
    if (!hpiAiLoading) {
      setHpiAiLoadingStep(0);
      return;
    }

    const intervalId = setInterval(() => {
      setHpiAiLoadingStep((prev) => {
        const next = prev + 1;
        return next >= hpiLoadingMessages.length ? prev : next;
      });
    }, 2000);

    return () => clearInterval(intervalId);
  }, [hpiAiLoading]);

  useEffect(() => {
    if (!mdmPlanAiLoading) {
      setMdmPlanAiLoadingStep(0);
      return;
    }

    const intervalId = setInterval(() => {
      setMdmPlanAiLoadingStep((prev) => {
        const next = prev + 1;
        return next >= mdmPlanLoadingMessages.length ? prev : next;
      });
    }, 2000);

    return () => clearInterval(intervalId);
  }, [mdmPlanAiLoading]);

  const AiPredictiveChartCard = ({
    isOpen,
    setIsOpen,
    loading,
    error,
    suggestions,
    newSuggestionsAvailable,
    onReload,
    onEditItem,
    loadingMessages,
    loadingStep,
  }) => {
    const aiChevronStyle = {
      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
      transition: "transform 0.2s ease",
      cursor: "pointer",
    };
    return (
    <>
      {/* Header / toggle */}
      <div
        className="ai-predictive-card d-flex w-100 align-items-center justify-content-between mb-2"
        style={{ ...aiPredictiveCardStyle, cursor: "pointer" }}
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen((prev) => !prev)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen((prev) => !prev);
          }
        }}
      >
        <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
          <span className="ai-predictive-icon d-flex align-items-center justify-content-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M12.0017 16.0019C12.0017 13.7918 13.7933 12.0002 16.0033 12.0002C13.7933 12.0002 12.0017 10.2086 12.0017 7.99854C12.0017 10.2086 10.2101 12.0002 8 12.0002C10.2101 12.0002 12.0017 13.7918 12.0017 16.0019Z" stroke="url(#paint0_linear_ai_hpi_card)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M21.0036 12.0001C21.0036 16.9727 16.9725 21.0038 11.9998 21.0038C7.02721 21.0038 2.99609 16.9727 2.99609 12.0001C2.99609 7.02745 7.02721 2.99634 11.9998 2.99634" stroke="url(#paint1_linear_ai_hpi_card)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path fillRule="evenodd" clipRule="evenodd" d="M19.0052 7.99835C19.0052 6.34081 20.3489 4.9971 22.0064 4.9971C20.3489 4.9971 19.0052 3.65339 19.0052 1.99585C19.0052 3.65339 17.6615 4.9971 16.0039 4.9971C17.6615 4.9971 19.0052 6.34081 19.0052 7.99835Z" stroke="url(#paint2_linear_ai_hpi_card)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <defs>
                <linearGradient id="paint0_linear_ai_hpi_card" x1="16.0033" y1="12.0002" x2="8" y2="12.0002" gradientUnits="userSpaceOnUse"><stop offset="0.0625" stopColor="#9AA1FF" /><stop offset="1" stopColor="#4474E6" /></linearGradient>
                <linearGradient id="paint1_linear_ai_hpi_card" x1="21.0036" y1="12.0001" x2="2.99609" y2="12.0001" gradientUnits="userSpaceOnUse"><stop offset="0.0625" stopColor="#9AA1FF" /><stop offset="1" stopColor="#4474E6" /></linearGradient>
                <linearGradient id="paint2_linear_ai_hpi_card" x1="22.0064" y1="4.99709" x2="16.0039" y2="4.99709" gradientUnits="userSpaceOnUse"><stop offset="0.0625" stopColor="#9AA1FF" /><stop offset="1" stopColor="#4474E6" /></linearGradient>
              </defs>
            </svg>
          </span>
          <p className="mb-0 text-dark font-weight-bold" style={{ ...aiPredictiveTitleStyle, lineHeight: 1.2 }}>
          AI - Predictive Charting
          </p>
        </div>
        <div className="d-flex align-items-center gap-1">
          {isOpen && (
            <button
              type="button"
              className="btn btn-light sh_btnlight d-flex align-items-center justify-content-center"
              aria-label="Reload suggestions"
              title="Reload suggestions"
              onClick={(e) => {
                e.stopPropagation();
                onReload?.(e);
              }}
              style={{ width: "34px", height: "34px", padding: 0 }}
            >
              <Icons type={"ReloadSuggestions"} size={16} color={"#4B5563"} />
            </button>
          )}
          <span className="ai-secondary-nav-chevron d-flex align-items-center justify-content-center" style={aiChevronStyle}>
            <svg fill="#000000" width="20" height="20" viewBox="-0.15 -0.225 0.72 0.72">
              <path d="m0.212 0.085 -0.148 0.148A0.03 0.03 0 0 1 0.021 0.191L0.191 0.021a0.03 0.03 0 0 1 0.042 0l0.17 0.17a0.03 0.03 0 0 1 -0.042 0.042z" />
            </svg>
          </span>
        </div>
      </div>

      {/* Expanded content */}
      {isOpen && (
        <div className="card-body px-0 py-2 sh_basecardBody sh_chart">
          <div className="ai-predictive-card h-100 d-flex flex-column" style={aiPredictiveCardStyle}>
            <div className="ai-predictive-list flex-grow-1" style={aiPredictiveListStyle}>
              {loading && (
                <div className="d-flex align-items-center justify-content-center py-2 text-center flex-column">
                  <div className="d-flex align-items-center justify-content-center mb-1">
                    <span
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        border: "3px solid rgba(126, 224, 255, 0.3)",
                        borderTopColor: "#7EE0FF",
                        animation: "aiSpin 0.8s linear infinite",
                        display: "inline-block",
                        marginRight: 8,
                      }}
                    />
                    <span style={{ color: "#4B5563", fontSize: "13px", fontWeight: 500 }}>
                      Generating AI narrative...
                    </span>
                  </div>
                  <span style={{ color: "#6B7280", fontSize: "12px" }}>
                    {loadingMessages?.[loadingStep] ?? ""}
                  </span>
                </div>
              )}

              {error && (
                <div style={{ color: "#ff6b6b", fontSize: "13px", fontWeight: "500", padding: "8px", backgroundColor: "rgba(255, 107, 107, 0.1)", borderRadius: "8px" }}>
                  {error}
                </div>
              )}

              {!loading && !error && suggestions.length === 0 && (
                <div style={{ color: "#4B5563", fontSize: "13px", textAlign: "center", padding: "8px" }}>
                  No suggestions available.
                </div>
              )}

              {!loading && !error && suggestions.map((item, index) => {
                const isAccepted = item.is_accepted || false;
                // For MDM/Plan suggestions, description may be JSON payload:
                // { mdm_plan, selections }. Show only mdm_plan in preview.
                const parsedMdm = parseMdmSuggestionDescription(item.description);
                let plainDescription = parsedMdm?.mdm_plan || item.description || "";
                try {
                  if (typeof document !== "undefined") {
                    const tmp = document.createElement("div");
                    tmp.innerHTML = plainDescription;
                    plainDescription = (tmp.textContent || tmp.innerText || "").trim();
                  }
                } catch (e) {
                  // Fallback: leave description as-is if DOM not available
                }
                return (
                  <div
                    key={`${item.id || item.code}-${index}`}
                    className={`ai-predictive-item d-flex align-items-start justify-content-between ${index === suggestions.length - 1 ? "mb-0" : "mb-2"}`}
                    style={{
                      opacity: isAccepted ? 0.6 : 1,
                      textDecoration: isAccepted ? "line-through" : "none",
                      borderBottom:
                        index === suggestions.length - 1
                          ? "none"
                          : "1px solid #E5E7EB",
                      paddingBottom: index === suggestions.length - 1 ? 0 : 8,
                    }}
                  >
                    <div className="me-3">
                      <p className="mb-1 font-weight-bold" style={aiPredictiveCodeStyle}>
                        {item.code}
                        {isAccepted && <span className="ml-2 text-success">✓</span>}
                      </p>
                      <p className="mb-0 text-muted small" style={aiPredictiveDescStyle}>
                        {plainDescription}
                        <br />
                        Confidence: {item.confidence != null
                          ? (typeof item.confidence === "number"
                              ? (item.confidence <= 1 ? `${Math.round(Number(item.confidence) * 100)}%` : `${Math.round(Number(item.confidence))}%`)
                              : `${String(item.confidence)}`)
                          : "N/A"}
                      </p>
                    </div>
                    <div style={{ paddingTop: "2px", flexShrink: 0 }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isAccepted}
                        aria-label={`Accept suggestion ${item.code || index + 1}`}
                        onChange={() => {
                          if (!isAccepted) {
                            onEditItem?.(item);
                          }
                        }}
                      />
                    </div>
                  </div>
                );
              })}
              <style>{`
                @keyframes aiSpin {
                  from { transform: rotate(0deg) }
                  to { transform: rotate(360deg) }
                }
              `}</style>
            </div>

            {!loading && !error && suggestions.length > 0 && (
              <div className="sh_cardFooter border-0 d-flex justify-content-between align-items-center" style={{ zIndex: 2 }}>
                <small style={{ color: "#4B5563", fontSize: "13px" }}>
                  {newSuggestionsAvailable ? "New suggestions available" : `${suggestions.length} suggestions`}
                </small>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
  };

  const normalizeId = (value) => (value === undefined || value === null ? "" : String(value));

  const getLatestSuggestionTimestamp = (suggestions = []) => {
    if (!suggestions.length) return null;
    const latestSuggestion = suggestions.reduce((latest, current) => {
      const currentTime = new Date(current.created_at || 0).getTime();
      const latestTime = new Date(latest.created_at || 0).getTime();
      return currentTime > latestTime ? current : latest;
    }, suggestions[0]);
    return latestSuggestion?.created_at || null;
  };

  // Keep this aligned with AIPrediction gating logic (e.g. NewIcdDisplay.js).
  const aiSuggestionsEnabled = profile?.ai_suggestions_enabled ?? false;
  // Show AI card only for HPI sub-tab (History) or Return/FollowUp sub-tab (Discharge), not e.g. School Note
  const isHpiSubTab = handleLabel(selectedSubTab) === "History of Present Illness";
  const isDischargeReturnFollowUp = selectedTab === "Discharge" && selectedSubTab === "RETURN_FOLLOWUP";
  const currentAiSuggestionType = isDischargeReturnFollowUp ? "discharge" : "hpi";
  const showHpiAiPredictive =
    aiSuggestionsEnabled &&
    (isHpiSubTab || isDischargeReturnFollowUp);
    console.log("selectedTab", selectedTab, "selectedSubTab", selectedSubTab);
  // Show AI card UI for the MDM / Plan charting section (no backend wiring yet).
  const isMdmPlanSubTab =selectedTab === "MDM / Plan" && selectedSubTab === "MDM_PLAN";
  const showMdmPlanAiPredictive = aiSuggestionsEnabled && isMdmPlanSubTab;

  const handleMdmPlanReloadSuggestions = async (e) => {
    if (e?.stopPropagation) e.stopPropagation();
    try {
      const organizationId = visitDetails?.organization_id;
      if (!visit_id || !organizationId) {
        setMdmPlanAiError("Missing visit or organization details");
        return;
      }

      setMdmPlanAiError("");
      setMdmPlanAiLoading(true);
      await AiDiagnosisService.generateSuggestionsByVisit(
        visit_id,
        organizationId,
        employeeId || null,
        "mdm_plan"
      );
      await fetchMdmPlanStoredSuggestions();
      setNewMdmPlanSuggestionsAvailable(false);
    } catch (err) {
      setMdmPlanAiError(err?.message || "Unable to reload MDM/Plan AI suggestions");
    } finally {
      setMdmPlanAiLoading(false);
    }
  };
  const fetchHpiStoredSuggestions = async (checkForNew = false) => {
    if (!visit_id) return [];
    try {
      setHpiAiLoading(true);
      setHpiAiError("");
      const data = await AiDiagnosisService.getSuggestions(visit_id, currentAiSuggestionType);
      const newSuggestions = data?.suggestions || [];

      if (checkForNew) {
        if (newSuggestions.length > 0) {
          const latestTimestamp = getLatestSuggestionTimestamp(newSuggestions);
          if (
            latestTimestamp &&
            (!lastKnownHpiSuggestionTimestamp ||
              lastKnownHpiSuggestionTimestamp === "CHECKED_EMPTY" ||
              new Date(latestTimestamp).getTime() > new Date(lastKnownHpiSuggestionTimestamp).getTime())
          ) {
            setNewHpiSuggestionsAvailable(true);
            setIsHpiPollingForNewSuggestions(false);
            setLastKnownHpiSuggestionTimestamp(latestTimestamp);
            setHasHpiCompletedPolling(true);
          }
        } else {
          setHasHpiCompletedPolling(true);
        }
      } else if (newSuggestions.length > 0) {
        const latestTimestamp = getLatestSuggestionTimestamp(newSuggestions);
        if (latestTimestamp) {
          setLastKnownHpiSuggestionTimestamp(latestTimestamp);
        }
      } else if (lastKnownHpiSuggestionTimestamp === null) {
        setLastKnownHpiSuggestionTimestamp("CHECKED_EMPTY");
      }

      setHpiAiSuggestions(newSuggestions);
      return newSuggestions;
    } catch (err) {
      setHpiAiError(err?.message || "Unable to fetch suggestions");
      return [];
    } finally {
      setHpiAiLoading(false);
    }
  };

  const fetchMdmPlanStoredSuggestions = async (checkForNew = false) => {
    if (!visit_id) return [];
    try {
      setMdmPlanAiLoading(true);
      setMdmPlanAiError("");

      const data = await AiDiagnosisService.getSuggestions(visit_id, "mdm_plan");
      const newSuggestions = data?.suggestions || [];

      if (checkForNew) {
        if (newSuggestions.length > 0) {
          const latestTimestamp = getLatestSuggestionTimestamp(newSuggestions);
          if (
            latestTimestamp &&
            (!lastKnownMdmPlanSuggestionTimestamp ||
              lastKnownMdmPlanSuggestionTimestamp === "CHECKED_EMPTY" ||
              new Date(latestTimestamp).getTime() > new Date(lastKnownMdmPlanSuggestionTimestamp).getTime())
          ) {
            setNewMdmPlanSuggestionsAvailable(true);
            setIsMdmPlanPollingForNewSuggestions(false);
            setLastKnownMdmPlanSuggestionTimestamp(latestTimestamp);
          }
        }
      } else if (newSuggestions.length > 0) {
        const latestTimestamp = getLatestSuggestionTimestamp(newSuggestions);
        if (latestTimestamp) {
          setLastKnownMdmPlanSuggestionTimestamp(latestTimestamp);
        }
      } else if (lastKnownMdmPlanSuggestionTimestamp === null) {
        setLastKnownMdmPlanSuggestionTimestamp("CHECKED_EMPTY");
      }

      setMdmPlanAiSuggestions(newSuggestions);
      return newSuggestions;
    } catch (err) {
      setMdmPlanAiError(err?.message || "Unable to fetch MDM/Plan suggestions");
      return [];
    } finally {
      setMdmPlanAiLoading(false);
    }
  };

  useEffect(() => {
    if (!visit_id || !isHpiAiPredictiveOpen || !showHpiAiPredictive) return;
    setHasHpiCompletedPolling(false);
    fetchHpiStoredSuggestions().then((suggestions) => {
      if (!suggestions || suggestions.length === 0) {
        const organizationId = visitDetails?.organization_id;
        if (organizationId) {
          setHpiAiLoading(true);
          AiDiagnosisService.generateSuggestionsByVisit(
            visit_id,
            organizationId,
            employeeId || null,
            currentAiSuggestionType
          )
            .then(() => {
              setIsHpiPollingForNewSuggestions(true);
              setNewHpiSuggestionsAvailable(false);
              setHasHpiCompletedPolling(false);
            })
            .catch((err) => setHpiAiError(err?.message || "Unable to generate suggestions"))
            .finally(() => setHpiAiLoading(false));
        }
      }
    });
  }, [visit_id, isHpiAiPredictiveOpen, currentAiSuggestionType, showHpiAiPredictive, visitDetails?.organization_id, employeeId]);

  useEffect(() => {
    if (!visit_id || !isHpiPollingForNewSuggestions) return;

    let pollCount = 0;
    const startedWithNoSuggestions = !lastKnownHpiSuggestionTimestamp || lastKnownHpiSuggestionTimestamp === "CHECKED_EMPTY";
    const maxPolls = startedWithNoSuggestions ? 5 : 15;
    let pollInterval = null;

    const poll = async () => {
      pollCount++;
      await fetchHpiStoredSuggestions(true);
      if (pollCount >= maxPolls) {
        if (pollInterval) {
          clearInterval(pollInterval);
        }
        setIsHpiPollingForNewSuggestions(false);
        setHasHpiCompletedPolling(true);
      }
    };

    poll();
    pollInterval = setInterval(poll, 2000);

    return () => {
      if (pollInterval) clearInterval(pollInterval);
    };
  }, [visit_id, isHpiPollingForNewSuggestions, lastKnownHpiSuggestionTimestamp, currentAiSuggestionType]);

  useEffect(() => {
    const handleEmrSave = () => {
      if (isHpiAiPredictiveOpen) {
        setIsHpiPollingForNewSuggestions(true);
        setNewHpiSuggestionsAvailable(false);
        setHasHpiCompletedPolling(false);
      }
    };
    window.addEventListener("emr-saved", handleEmrSave);
    return () => window.removeEventListener("emr-saved", handleEmrSave);
  }, [isHpiAiPredictiveOpen]);

  // ===== MDM / Plan AI (mdm_plan) =====
  useEffect(() => {
    if (!visit_id || !isMdmPlanAiPredictiveOpen || !showMdmPlanAiPredictive) return;

    fetchMdmPlanStoredSuggestions().then((suggestions) => {
      if (!suggestions || suggestions.length === 0) {
        const organizationId = visitDetails?.organization_id;
        if (organizationId) {
          setMdmPlanAiLoading(true);
          AiDiagnosisService.generateSuggestionsByVisit(
            visit_id,
            organizationId,
            employeeId || null,
            "mdm_plan"
          )
            .then(() => {
              setIsMdmPlanPollingForNewSuggestions(true);
              setNewMdmPlanSuggestionsAvailable(false);
            })
            .catch((err) => setMdmPlanAiError(err?.message || "Unable to generate suggestions"))
            .finally(() => setMdmPlanAiLoading(false));
        }
      }
    });
  }, [
    visit_id,
    isMdmPlanAiPredictiveOpen,
    showMdmPlanAiPredictive,
    visitDetails?.organization_id,
    employeeId,
  ]);

  useEffect(() => {
    if (!visit_id || !isMdmPlanPollingForNewSuggestions) return;

    let pollCount = 0;
    const startedWithNoSuggestions =
      !lastKnownMdmPlanSuggestionTimestamp ||
      lastKnownMdmPlanSuggestionTimestamp === "CHECKED_EMPTY";
    const maxPolls = startedWithNoSuggestions ? 5 : 15;
    let pollInterval = null;

    const poll = async () => {
      pollCount++;
      await fetchMdmPlanStoredSuggestions(true);
      if (pollCount >= maxPolls) {
        if (pollInterval) {
          clearInterval(pollInterval);
        }
        setIsMdmPlanPollingForNewSuggestions(false);
      }
    };

    poll();
    pollInterval = setInterval(poll, 2000);

    return () => {
      if (pollInterval) clearInterval(pollInterval);
    };
  }, [visit_id, isMdmPlanPollingForNewSuggestions, lastKnownMdmPlanSuggestionTimestamp]);

  useEffect(() => {
    const handleEmrSave = () => {
      if (isMdmPlanAiPredictiveOpen) {
        setIsMdmPlanPollingForNewSuggestions(true);
        setNewMdmPlanSuggestionsAvailable(false);
      }
    };
    window.addEventListener("emr-saved", handleEmrSave);
    return () => window.removeEventListener("emr-saved", handleEmrSave);
  }, [isMdmPlanAiPredictiveOpen]);

  const handleHpiReloadSuggestions = async (e) => {
    if (e) e.stopPropagation();

    try {
      const organizationId = visitDetails?.organization_id;

      if (!visit_id || !organizationId) {
        setHpiAiError("Missing visit or organization details");
        return;
      }

      setHpiAiLoading(true);
      await AiDiagnosisService.generateSuggestionsByVisit(
        visit_id,
        organizationId,
        employeeId || null,
        currentAiSuggestionType
      );
      await fetchHpiStoredSuggestions();
      setNewHpiSuggestionsAvailable(false);
    } catch (err) {
      setHpiAiError(err?.message || "Unable to reload AI suggestions");
    } finally {
      setHpiAiLoading(false);
    }
  };

  const handleHpiAcceptSuggestion = async (item) => {
    try {
      const organizationId = visitDetails?.organization_id;

      if (item?.id && organizationId && visit_id) {
        await AiDiagnosisService.acceptSuggestion(item.id, organizationId, visit_id);
      }

      const clickedKey = normalizeId(
        item?.id ||
        item?.suggestion_id ||
        item?.icd_id ||
        item?.matched_icd_id ||
        item?.icd10_id ||
        item?.code
      );
      setHpiAiSuggestions((prev) =>
        prev.map((suggestion) => {
          const suggestionKey = normalizeId(
            suggestion?.id ||
            suggestion?.suggestion_id ||
            suggestion?.icd_id ||
            suggestion?.matched_icd_id ||
            suggestion?.icd10_id ||
            suggestion?.code
          );
          return suggestionKey === clickedKey
            ? { ...suggestion, is_accepted: true, is_in_assessment: true }
            : suggestion;
        })
      );

      await fetchHpiStoredSuggestions();
      dispatch(success("Suggestion accepted"));
    } catch (err) {
      setHpiAiError(err?.message || "Unable to accept suggestion");
    }
  };

  const openMdmPlanEditModal = (item) => {
    setMdmPlanEditSuggestion(item);
    const parsed = parseMdmSuggestionDescription(item?.description);
    const narrative = String(parsed?.mdm_plan || item?.description || "");
    const selections = parsed?.selections && typeof parsed.selections === "object" ? parsed.selections : {};
    const editorText = buildMdmEditorHtml(narrative, selections);
    setMdmPlanEditText(editorText);
    setMdmPlanEditSelections(selections);
    setMdmPlanAiError("");
    setIsMdmPlanEditModalOpen(true);
  };

  const applyMdmPlanSelectionsToEmr = async (targetFormId, normalizedNarrative, selectionsMap) => {
    const formResponse = await EmrConfigService.getEmrFormById("MDM_PLAN", targetFormId);
    const formData = formResponse?.data || formResponse;
    const setupFields = Array.isArray(formData?.fields) ? formData.fields : [];

    const normalizeKey = (val) => String(val || "").trim().toLowerCase();
    const parseColumnHeader = (columnHeader) => {
      if (Array.isArray(columnHeader)) return columnHeader;
      if (typeof columnHeader === "string") {
        try {
          const parsed = JSON.parse(columnHeader);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    };

    const findSelectionByFieldLabel = (label) => {
      if (!selectionsMap || typeof selectionsMap !== "object") return {};
      const target = normalizeKey(label);
      const matchKey = Object.keys(selectionsMap).find((k) => normalizeKey(k) === target);
      return matchKey ? selectionsMap[matchKey] || {} : {};
    };

    const buildCustomMatrixValue = (field, fieldSelection) => {
      const rowValueToId = {};
      (field?.options || []).forEach((opt) => {
        if (opt?.id) rowValueToId[normalizeKey(opt?.value)] = opt.id;
      });

      const columnMap = {};
      parseColumnHeader(field?.column_header).forEach((entry) => {
        const label = typeof entry === "string" ? entry : (entry?.label || entry?.value || "");
        if (label) columnMap[normalizeKey(label)] = String(label);
      });

      const value = {};
      Object.entries(fieldSelection || {}).forEach(([columnLabel, rowValues]) => {
        const mappedColumn = columnMap[normalizeKey(columnLabel)] || String(columnLabel || "").trim();
        if (!mappedColumn || !Array.isArray(rowValues)) return;
        rowValues.forEach((rowValue) => {
          const rowId = rowValueToId[normalizeKey(rowValue)];
          if (!rowId) return;
          value[rowId] = value[rowId] || [];
          if (!value[rowId].includes(mappedColumn)) value[rowId].push(mappedColumn);
        });
      });

      return value;
    };

    const payloadFields = setupFields.map((field) => {
      const inputType = field?.field_type?.input_type || field?.fieldType?.input_type;

      if (inputType === "CUSTOM_MATRIX") {
        const selection = findSelectionByFieldLabel(field?.label);
        return {
          field_id: field.id,
          value: buildCustomMatrixValue(field, selection),
        };
      }

      if ((inputType === "TEXT_FIELD" || inputType === "TEXT_AREA" || inputType === "RICH_TEXT") &&
          (String(field?.id) === MDM_PLAN_DICTATION_FIELD_ID || /mdm\s*\/\s*plan/i.test(String(field?.label || "")))) {
        return {
          field_id: field.id,
          value: normalizedNarrative,
          meta: { source: "ai_dictation", ai_type: "mdm_plan" },
        };
      }

      return {
        field_id: field.id,
        value: "",
      };
    });

    const payload = {
      employee_id: employeeId,
      emr_field: payloadFields,
      screen_type: "MDM_PLAN",
    };

    await EmrVisitsService.saveFields(null, visit_id, targetFormId, payload);
  };

  const handleMdmPlanEditSave = async () => {
    if (!mdmPlanEditSuggestion) {
      setIsMdmPlanEditModalOpen(false);
      return;
    }

    if (typeof Loader === "function") {
      Loader(true);
    }
    try {
      const organizationId = visitDetails?.organization_id;
      if (!visit_id || !organizationId || !employeeId) {
        setMdmPlanAiError("Missing visit, organization, or employee details");
        return;
      }

      const normalizedNarrative = normalizeMdmNarrativeForSave(mdmPlanEditText, mdmPlanEditSelections);
      await applyMdmPlanSelectionsToEmr(
        MDM_PLAN_DICTATION_FORM_ID,
        normalizedNarrative,
        mdmPlanEditSelections
      );

      // Force-refresh the charting form so the saved value appears immediately.
      if (typeof handleCheckboxChange === "function") {
        await handleCheckboxChange(
          MDM_PLAN_DICTATION_FORM_ID,
          true,
          true,
          true
        );
      }

      // Mark suggestion accepted in AI table.
      try {
        await AiDiagnosisService.acceptSuggestion(
          mdmPlanEditSuggestion.id,
          organizationId,
          visit_id
        );
      } catch (acceptErr) {
        // Saving EMR content is the primary requirement; do not block on accept.
      }

      // Close the editor modal.
      setIsMdmPlanEditModalOpen(false);
      setIsMdmPlanAiPredictiveOpen(false);

      if (typeof handleTick === "function" && selectedTab && selectedSubTab) {
        await handleTick(
          Array.from(new Set([...(finishedTabs || []), selectedTab])),
          Array.from(new Set([...(finishedSubTabs || []), selectedSubTab]))
        );
      }

      // Refresh tab status to see completed ticks if needed.
      if (props?.fetchTabsList) {
        await props.fetchTabsList();
      }
      if (props.refreshEmrFields) {
        await props.refreshEmrFields();
      }
      if (fetchProgressNotesByScreen) {
        await fetchProgressNotesByScreen();
      }

      await fetchMdmPlanStoredSuggestions();
      dispatch(success("MDM/Plan saved successfully"));
    } catch (error) {
      setMdmPlanAiError(error?.message || "Unable to save MDM/Plan text to charting");
    } finally {
      if (typeof Loader === "function") {
        Loader(false);
      }
    }
  };

  const openHpiEditModal = (item) => {
    setHpiEditSuggestion(item);
    setHpiEditText(item?.description || "");
    setHpiAiError("");
    setIsHpiEditModalOpen(true);
  };

  const handleHpiEditSave = async () => {
    if (!hpiEditSuggestion) {
      setIsHpiEditModalOpen(false);
      return;
    }

    try {
      const organizationId = visitDetails?.organization_id;

      if (!visit_id || !organizationId || !employeeId) {
        setHpiAiError("Missing visit, organization, or employee details");
        return;
      }

      const HPI_DICTATION_FORM_ID = "330ab951b43842c883450355351642aa";
      const HPI_DICTATION_FIELD_ID = "51e3ad36a5464daf88ccf836df6b5750";
      const DISCHARGE_DICTATION_FORM_ID = "87cd15701d6b4fe8b5735ef4c09ad261";
      const DISCHARGE_DICTATION_FIELD_ID = "fc111416745243609b28a0bfca28d449";

      // Decide where to save based on AI type:
      // - 'hpi'      → screen_type HPI, HPI dictation field
      // - 'discharge'→ screen_type RETURN_FOLLOWUP, discharge field id
      const isDischarge = currentAiSuggestionType === "discharge";
      const targetFormId = isDischarge ? DISCHARGE_DICTATION_FORM_ID : HPI_DICTATION_FORM_ID;
      const targetFieldId = isDischarge ? DISCHARGE_DICTATION_FIELD_ID : HPI_DICTATION_FIELD_ID;
      const targetScreenType = isDischarge ? "RETURN_FOLLOWUP" : "HPI";
      const normalizedTextForField = isDischarge
        ? normalizeEditorHtmlToPlainText(hpiEditText)
        : (hpiEditText || "");

      const payload = {
        employee_id: employeeId,
        emr_field: [
          {
            field_id: targetFieldId,
            value: normalizedTextForField,
            // Let backend know this came from AI dictation so it can
            // skip adding before/after text or other wrappers.
            meta: {
              source: "ai_dictation",
              ai_type: currentAiSuggestionType,
              // Keep rich formatting in progress note, while field value can be plain text.
              progress_note_html: hpiEditText || "",
            },
          },
        ],
        screen_type: targetScreenType,
      };

      await EmrVisitsService.saveFields(null, visit_id, targetFormId, payload);

      // Force-refresh the specific EMR form so prefilled data updates immediately
      if (typeof handleCheckboxChange === "function") {
        // replace=true, forceRefresh=true (see ChartingSection.js implementation)
        await handleCheckboxChange(HPI_DICTATION_FORM_ID, true, true, true);
      }

      try {
        await handleHpiAcceptSuggestion(hpiEditSuggestion);
      } catch (e) {
        // Ignore accept errors; main goal is saving to EMR
      }

      // Close the AI edit modal
      setIsHpiEditModalOpen(false);
      setIsHpiAiPredictiveOpen(false);

      // Refresh tab status to see changes in real time
      if (props.fetchTabsList) {
        await props.fetchTabsList();
      }
      // Refresh all EMR fields after data is populated
      if (props.refreshEmrFields) {
        await props.refreshEmrFields();
      }
      // Refresh progress note in the UI so it shows the latest saved content
      if (fetchProgressNotesByScreen) {
        await fetchProgressNotesByScreen();
      }
    } catch (error) {
      setHpiAiError(error?.message || "Unable to save HPI text to charting");
    }
  };

  // const checkUnsavedChanges = (callback) => { 
  //   console.log("isChartingSectionDirty in SubTabChartingSection:", isChartingSectionDirty);
  //   if (isChartingSectionDirty) {
  //     const confirm = window.confirm(
  //       "You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
  //     );
  //     if (confirm) {
  //       setIsChartingSectionDirty(false); // User confirmed, clear dirty status
  //       callback();
  //     }
  //     return !confirm; // Return true if navigation was blocked
  //   }
  //   console.log("No unsaved changes, proceeding with callback.");
  //   callback(); // No unsaved changes, proceed
  //   return false; // Navigation proceeded
  // };
  
    const isEligibleForAllNormal = (form) =>
      form &&
      !Boolean(form.display_as_section_header || 0) &&
      form.show_normal !== false &&
      form.show_normal !== 0;

    const handleNormalClass = () => {
        const withShowNormal = fields.filter(isEligibleForAllNormal);
        if (withShowNormal.length === 0) return "";
        return withShowNormal.every((f) =>
            normalCheckedFormIds.includes(f.emr_form_id)
        )
            ? "normal"
            : withShowNormal.some((f) =>
                  normalCheckedFormIds.includes(f.emr_form_id)
              )
            ? "inactive"
            : "";
    }
    const handleNormalClick = async () => {
        if (fields.length === 0) return;
        const fieldsWithShowNormal = fields.filter(
            (f) => f.show_normal !== false && f.show_normal !== 0
        );
        if (fieldsWithShowNormal.length === 0) return;
        const allSelected =
            fieldsWithShowNormal.length > 0 &&
            fieldsWithShowNormal.every((f) =>
                normalCheckedFormIds.includes(f.emr_form_id)
            );

        const formIdsToProcess = fieldsWithShowNormal
            .filter((f) =>
                allSelected
                    ? normalCheckedFormIds.includes(f.emr_form_id)
                    : !normalCheckedFormIds.includes(f.emr_form_id)
            )
            .map((f) => f.emr_form_id);

        if (formIdsToProcess.length === 0) return;
        const combinedIds = formIdsToProcess.join(",");

        await handleNormalSubmit(
            combinedIds,
            allSelected ? 0 : 1,
            allSelected ? 1 : 0
        );

        if (allSelected) {
            setNormalCheckedFormIds((prev) =>
                prev.filter((id) =>
                    fields.every((f) => !formIdsToProcess.includes(id))
                )
            );
        } else {
            setNormalCheckedFormIds((prev) => [
                ...new Set([...prev, ...formIdsToProcess]),
            ]);

            setSelectedFormIds((prev) =>
                prev.filter(
                    (id) => !fields.some((f) => f.emr_form_id === id)
                )
            );
            setCompetedFormIds((prev) =>
                prev.filter(
                    (id) => !fields.some((f) => f.emr_form_id === id)
                )
            );
        }
    }
    const handleCClass=()=>{
        let val = ""
        fields.length > 0
            ? fields.every((f) =>
                selectedFormIds.includes(f.emr_form_id)
            )
                ?val="chart"
                : fields.some((f) =>
                    selectedFormIds.includes(f.emr_form_id)
                )
                    ?val="inactive"
                    :val= ""
            : val=""
        return val;
    }
    const handleCClick = async() => {
        if (fields.length === 0) return;
                    const allSelectedNow =
                      fields.length > 0 &&
                      fields.every((f) =>
                        selectedFormIds.includes(f.emr_form_id)
                      );

                    const formIdsToProcess = fields
                      .filter(
                        (f) =>
                          allSelectedNow
                            ? selectedFormIds.includes(f.emr_form_id) // being removed
                            : !selectedFormIds.includes(f.emr_form_id) // being added
                      )
                      .map((f) => f.emr_form_id);

                    const combinedIds = formIdsToProcess.join(",");

                    // 🔁 Call API with correct flag
                    await handleNormalSubmit(
                      combinedIds,
                      0,
                      allSelectedNow ? 1 : 0
                    );

                    if (allSelectedNow) {
                      // Deselect all charts
                      setSelectedFormIds((prev) =>
                        prev.filter(
                          (id) => !fields.some((f) => f.emr_form_id === id)
                        )
                      );
                      setCompetedFormIds((prev) =>
                        prev.filter(
                          (id) => !fields.some((f) => f.emr_form_id === id)
                        )
                      );
                      
                    } else {
                      // Select all charts
                      const newIds = fields.map((f) => f.emr_form_id);
                      setSelectedFormIds((prev) => [
                        ...new Set([...prev, ...newIds]),
                      ]);
                      setCompetedFormIds((prev) => [
                        ...new Set([...prev, ...newIds]),
                      ]);

                      // Uncheck all N
                      setNormalCheckedFormIds((prev) =>
                        prev.filter(
                          (id) => !fields.some((f) => f.emr_form_id === id)
                        )
                      );

                      fields.forEach(({ emr_form_id, name }) => {
                        if (!selectedFormIds.includes(emr_form_id)) {
                          handleCheckboxChange(emr_form_id, true);
                          if (fieldSearched) {
                            handleSearch(emr_form_id, name, false);
                            SetFieldSearched(false);
                          }
                        }
                      });
                    }
    }
// SubTabChartingSection.js

const handleChartClick = async (type, emr_form_id, fields) => {
  console.log("handleChartClick called with:", { type, emr_form_id, fields });
  console.log("isChartingSectionDirty in handleChartClick:", isChartingSectionDirty);
  if (type === "normal") {
      
      // Auto-save current charting when switching section (no unsaved modal)
      const proceed = saveCurrentChartingAndProceed || checkUnsavedChanges;
      proceed(async () => {
          const isChecked = normalCheckedFormIds.includes(emr_form_id);
          const newChecked = !isChecked;

          // Update local state (Normal)
          setNormalCheckedFormIds((prev) =>
              newChecked
                  ? [...prev, emr_form_id]
                  : prev.filter((id) => id !== emr_form_id)
          );

          // Uncheck C if new N is checked (clearing the C/Chart status)
          if (newChecked) {
              setSelectedFormIds((prev) =>
                  prev.filter((id) => id !== emr_form_id)
              );
              setCompetedFormIds((prev) =>
                  prev.filter((id) => id !== emr_form_id)
              );
          }
          
          // Clear the actual form data for this form
          clearData(emr_form_id)
          
          // Update finished tabs status
          props.SetFinishedTabs((prev) => (Array.from(new Set([...prev, selectedTab]))))
          props.SetFinishedSubTabs((prev) => (Array.from(new Set([...prev, selectedSubTab]))))
          
          await handleTick(Array.from(new Set([...finishedTabs, selectedTab])), Array.from(new Set([...finishedSubTabs, selectedSubTab])))
          
          // Call API with dynamic values (0=Uncheck, 1=Check)
          await handleNormalSubmit(
              emr_form_id,
              newChecked ? 1 : 0,
              newChecked ? 0 : 1
          );
      });

  } else if (type === "chart") {
    const proceed = saveCurrentChartingAndProceed || checkUnsavedChanges;
    proceed(async () => {
      const isChecked = selectedFormIds.includes(emr_form_id);
      const newChecked = !isChecked;
      // console.log("Chart click - isChecked:", isChecked, "newChecked:", newChecked); 
      // Note: The Chart/C click typically doesn't clear data, so the guard is
      // not strictly needed here unless this action triggers a form save/clear elsewhere.
      
      handleCheckboxChange(emr_form_id, newChecked);

      // if (newChecked) {
      //     // Logic to uncheck N when C is selected (already covered in other functions, keeping as comment)
      // }
    });
      
  }
}
    const clearData=(id)=>{        
        let newFormState = {}
        const obj = formResponses.find((item) => item.emr_form_id === id)
       
         obj && obj.fields.forEach((field) => {
                if ((field.id in formState)) {
                    newFormState[field.id] = '';
                }
            });
     
        setFormState((prev) => ({ ...prev, ...newFormState }));
    }
    function handleLabel(key) {
      const label = subTabs.find((item) => item.apikey === key)?.label;
      if (label === 'HPI') {
        return 'History of Present Illness';
      } else if (label === 'PMH') {
        return 'Past Medical History';
      } else if (label === 'ROS') {
        return 'Review of Systems';
      }
      return label;
    }

    const isHistorySubTab = () => {
        const label = handleLabel(selectedSubTab);
        return (
          label === "History of Present Illness" ||
          label === "Past Medical History" ||
          label === "Review of Systems"
        );
      };

// SubTabChartingSection.js

const handleAllNormalClick = async () => {
  const proceed = saveCurrentChartingAndProceed || checkUnsavedChanges;
  proceed(async () => {
      if (fields.length === 0) return;

      const fieldsWithShowNormal = fields.filter(isEligibleForAllNormal);
      if (fieldsWithShowNormal.length === 0) return;

      // Check if all fields (with Show Normal) are already marked as normal
      const allSelected = fieldsWithShowNormal.every((f) =>
        normalCheckedFormIds.includes(f.emr_form_id)
      );
    
      // ... (rest of the bulk logic remains here) ...
      
      // Collect all emr_form_ids to process
      const formIdsToProcess = fieldsWithShowNormal
        .filter((f) =>
          allSelected
            ? normalCheckedFormIds.includes(f.emr_form_id)
            : !normalCheckedFormIds.includes(f.emr_form_id)
        )
        .map((f) => f.emr_form_id);
    
      if (formIdsToProcess.length === 0) return;
    
      // Convert IDs into a comma-separated string
      const combinedIds = formIdsToProcess.join(",");
    
      // ✅ Call API once for all IDs
      await handleNormalSubmit(
        combinedIds,
        allSelected ? 0 : 1,
        allSelected ? 1 : 0
      );
    
      if (allSelected) {
        // ✅ If all are already normal, uncheck them
        setNormalCheckedFormIds((prev) =>
          prev.filter((id) => !formIdsToProcess.includes(id))
        );
      } else {
        // ✅ Mark all as normal in bulk
        setNormalCheckedFormIds((prev) => [
          ...new Set([...prev, ...formIdsToProcess]),
        ]);
    
        // ✅ Remove from charted lists
        setSelectedFormIds((prev) =>
          prev.filter((id) => !formIdsToProcess.includes(id))
        );
        setCompetedFormIds((prev) =>
          prev.filter((id) => !formIdsToProcess.includes(id))
        );
    
        // ✅ Clear data for all selected forms
        formIdsToProcess.forEach((id) => clearData(id));
      }
    
      // ✅ Update Finished Tabs and SubTabs
      props.SetFinishedTabs((prev) =>
        Array.from(new Set([...prev, selectedTab]))
      );
      props.SetFinishedSubTabs((prev) =>
        Array.from(new Set([...prev, selectedSubTab]))
      );
    
      // ✅ Update ticks after bulk update
      await handleTick(
        Array.from(new Set([...finishedTabs, selectedTab])),
        Array.from(new Set([...finishedSubTabs, selectedSubTab]))
      );
  });
};

  const handlerFilter=(e)=>{
    // const isChecked= e.target.checked;
    // const status= isChecked ? 1 : 0;
    console.log("status",e);
    // Calculate the new status value first (e is 1 or 0 from Checkbox component)
    const newStatus = Boolean(e);
    // Update state
    setSearchTerm('');
    setToggleStatus(newStatus);
    // Call fetchEmrList with the new status value directly to avoid stale state
    fetchEmrList(newStatus);
  }
    return (
      <div class="col-3">
        <div class="card sh_basecard">
          <div class="card-header p-2 sh_basecardHeader">
            <div class="d-flex w-100 justify-content-between align-items-center ">
              {/* {handleLabel(selectedSubTab)}
               */}
              <span>{handleLabel(selectedSubTab)}</span>
                
              <div className="">
                 {/* <div><span>{handleLabel(selectedSubTab)}</span></div> */}
                 <div className="d-flex align-items-center">
                    {isHistorySubTab() ? (
                      /* ===== HISTORY (HPI / PMH / ROS) – show All normal only when at least one field has Show Normal ===== */
                      fields.some((f) => f.show_normal !== false && f.show_normal !== 0) ? (
                      <div className="d-flex align-items-center">
                        <div>
                          <span
                            className={`sh_emrbadge ${handleNormalClass()}`}
                            title="Mark all as Normal"
                            onClick={handleAllNormalClick}
                            role="checkbox"
                            aria-checked={handleNormalClass() === "normal"}
                            tabIndex={0}
                          >
                            N
                          </span>
                        </div>
                      {/* C column spacer (invisible, keeps alignment) */}
                      <div style={{ width: "27px" }} />
                      </div>
                      ) : null
                    ) : (
                      /* ===== OTHER TABS (keep toggle) ===== */
                      <div className={toggleStatus ? "mr-3" : ""}>
                        <a title="Active">
                          <span className="d-flex align-items-center">
                            <label className="switch">
                              <FormInputs
                                className="form-check-input"
                                type="Checkbox"
                                name="activationstatus"
                                id="activationstatus"
                                value={toggleStatus}
                                changeHandler={(e) => handlerFilter(e)}
                              />
                              <span className="slider"></span>
                            </label>
                          </span>
                        </a>
                      </div>
                    )}
                  </div>

              { toggleStatus && <div className=" emrinlinesearchbox ">
                  {/* <Buttons
             className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
             clickHandler={handleSearch}
             iconType={"SearchDarkBg"}
             /> */}
                  <button
                    type="button"
                    className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
                    onClick={handleSearch}
                  >
                    <Icons type={"SearchDarkBg"} />
                  </button>
                  <FormInputs
                    type="text"
                    name="text"
                    className="emrinlinesearchinput"
                    placeholder="search.."
                    value={searchTerm}
                    changeHandler={(val) => {
                      setSearchTerm(val);
                      setActiveSearchSource("field");
                      setCurrentSearchLabel(val);
                    }}
                    readOnly={
                      activeSearchSource === "selectlist" ||
                      activeSearchSource === "history"
                    }
                  />
                </div>}
               
              </div>
            </div>
          </div>
          <div className="card-body p-2 sh_basecardBody">
            {showHpiAiPredictive && (
              <AiPredictiveChartCard
                isOpen={isHpiAiPredictiveOpen}
                setIsOpen={setIsHpiAiPredictiveOpen}
                loading={hpiAiLoading}
                error={hpiAiError}
                suggestions={hpiAiSuggestions}
                newSuggestionsAvailable={newHpiSuggestionsAvailable}
                onReload={handleHpiReloadSuggestions}
                onEditItem={openHpiEditModal}
                loadingMessages={hpiLoadingMessages}
                loadingStep={hpiAiLoadingStep}
              />
            )}
            {showMdmPlanAiPredictive && (
              <AiPredictiveChartCard
                isOpen={isMdmPlanAiPredictiveOpen}
                setIsOpen={setIsMdmPlanAiPredictiveOpen}
                loading={mdmPlanAiLoading}
                error={mdmPlanAiError}
                suggestions={mdmPlanAiSuggestions}
                newSuggestionsAvailable={newMdmPlanSuggestionsAvailable}
                onReload={handleMdmPlanReloadSuggestions}
                onEditItem={openMdmPlanEditModal}
                loadingMessages={mdmPlanLoadingMessages}
                loadingStep={mdmPlanAiLoadingStep}
              />
            )}
            {(!showHpiAiPredictive || !isHpiAiPredictiveOpen) &&
              (!showMdmPlanAiPredictive || !isMdmPlanAiPredictiveOpen) && (
              <>
            <div className="d-flex flex-column gap-2">
              {fields.map(({ emr_form_id, name, display_as_section_header, show_normal :showNormal}, idx) => {
                const id = `field-check-${emr_form_id}`;
                const isChecked = selectedFormIds.includes(emr_form_id);
                const isSectionHeader = Boolean(display_as_section_header || 0);
                const showNormalButton = showNormal !== false && showNormal !== 0;
                const sectionHeaderText = String(name || "")
                  .replace(/^\s*-+\s*/, "")
                  .replace(/\s*-+\s*$/, "")
                  .trim();
                return (
                  <div
                    className="d-flex w-100 justify-content-between align-items-center "
                    key={id}
                  >
                    {isSectionHeader ? (
                      <div
                        className="w-100 d-flex align-items-center"
                        style={{
                          minHeight: "22px",
                          background: "linear-gradient(90deg, #eef8ff 0%, #fffde9 100%)",
                          borderRadius: "3px",
                          padding: "2px 8px",
                          overflow: "hidden",
                          minWidth: 0,
                        }}
                      >
                        <span
                          style={{
                            fontSize: "10px",
                            letterSpacing: "4px",
                            color: "#6d7482",
                            fontWeight: 500,
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                          }}
                        >
                          {sectionHeaderText}
                        </span>
                        <span
                          style={{
                            height: "1px",
                            backgroundColor: "#9aa7bf",
                            flex: "1 1 auto",
                            marginLeft: "12px",
                            opacity: 0.9,
                            minWidth: "20px",
                          }}
                        />
                      </div>
                    ) : (
                      <>
                        <p className="sh_emrtext p2-light mb-0"> {name} </p>
                        <div className="d-flex align-items-center">
                          <div className="">
                            {selectedTab === "Order/Results" ||
                            selectedTab === "Assessment" ? (
                              <span
                                style={{
                                  display: "inline-block",
                                }}
                              >
                                {/* <Icons type={"blue"} fontSize={"23px"} /> */}
                              </span>
                            ) : showNormalButton ? (
                              <span
                                className={`sh_emrbadge ${
                                  normalCheckedFormIds.includes(emr_form_id)
                                    ? "normal"
                                    : selectedFormIds.includes(emr_form_id)
                                    ? "inactive"
                                    : ""
                                }`}
                                title="Normal"
                                onClick={() =>
                                  handleChartClick("normal", emr_form_id, fields)
                                }
                                role="checkbox"
                                aria-checked={normalCheckedFormIds.includes(
                                  emr_form_id
                                )}
                                tabIndex={0}
                              >
                                N
                              </span>
                            ): null}
                          </div>
                          <div className="">
                            <span
                              className={`sh_emrbadge ml-1 ${
                                selectedFormIds.includes(emr_form_id)
                                  ? "chart"
                                  : props.completedFormIds.includes(emr_form_id)
                                  ? "charted"
                                  : normalCheckedFormIds.includes(emr_form_id)
                                  ? "inactive"
                                  : ""
                              }`}
                              title="Chart"
                              onClick={() =>
                                handleChartClick("chart", emr_form_id, fields)
                              }
                              role="checkbox"
                              aria-checked={isChecked}
                              tabIndex={0}
                            >
                              C
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
            </>
              )}
          </div>
        </div>
        {isHpiEditModalOpen && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1050,
      padding: "20px",
    }}
    onClick={() => setIsHpiEditModalOpen(false)}
  >
    <div
      className="card shadow-lg"
      style={{
        width: "650px",
        maxWidth: "100%",
        maxHeight: "85vh",
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="card-header py-2">
        <strong>
          {currentAiSuggestionType === "discharge"
            ? "Edit Discharge Instructions from AI suggestion"
            : "Edit HPI - Provider Entry / Dictation from AI suggestion"}
        </strong>
      </div>

      <div
        className="card-body"
        style={{
          overflowY: "auto",
          flex: 1,
        }}
      >
        <FormInputs
          type="Editor"
          value={hpiEditText}
          height="250px"
          formats={{
            formats: ['bold', 'italic', 'underline', 'list'],
          }}
          modules={{
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
          }}
          changeHandler={(value) => {
            // Editor keeps HTML under the hood, but user sees rich text instead of raw tags.
            setHpiEditText(value || "");
          }}
        />
      </div>

      <div className="card-footer d-flex justify-content-end gap-2">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => setIsHpiEditModalOpen(false)}
        >
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleHpiEditSave}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}

        {isMdmPlanEditModalOpen && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1050,
      padding: "20px",
    }}
    onClick={() => setIsMdmPlanEditModalOpen(false)}
  >
    <div
      className="card shadow-lg"
      style={{
        width: "650px",
        maxWidth: "100%",
        maxHeight: "85vh",
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="card-header py-2">
        <strong>Edit MDM/Plan from AI suggestion</strong>
      </div>

      <div
        className="card-body mdm-plan-editor-single-scroll"
        style={{
          overflowY: "auto",
          flex: 1,
        }}
      >
        <style>{`
          .mdm-plan-editor-single-scroll .ql-container {
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
          }
          .mdm-plan-editor-single-scroll .ql-toolbar {
            display: none !important;
          }
          .mdm-plan-editor-single-scroll .ql-editor {
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
            min-height: 250px;
          }
        `}</style>
        <FormInputs
          type="Editor"
          value={mdmPlanEditText}
          readOnly={true}
          formats={{
            formats: ["bold", "italic", "underline", "list"],
          }}
          modules={{
            toolbar: false,
          }}
          changeHandler={() => {}}
        />
        {mdmPlanAiError && (
          <div
            style={{
              color: "#ff6b6b",
              fontSize: "13px",
              fontWeight: "500",
              padding: "8px",
              backgroundColor: "rgba(255, 107, 107, 0.1)",
              borderRadius: "8px",
              marginTop: 8,
            }}
          >
            {mdmPlanAiError}
          </div>
        )}
      </div>

      <div className="card-footer d-flex justify-content-end gap-2">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => setIsMdmPlanEditModalOpen(false)}
        >
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleMdmPlanEditSave}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default SubTabChartingSection